import { ContasPagamentoForm } from "../../../presentation/schemas/ContasPagar_lista/ContasPagar_pagamento";
import { IPagamentoContasUseCase } from "../../../presentation/useCases/update/pagamento_contas_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * RecebimentoContasUseCase
 */

export class PagamentoContasUseCase implements IPagamentoContasUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async pagamentoContas(form: ContasPagamentoForm): Promise<void> {

    await this.repository.contasPagamento(form)
  }
}
